import { BrowserModule } from '@angular/platform-browser';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { HttpClientModule, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';

import { AppRoutingModule } from '@/app-routing.module';
import { AppComponent } from './app.component';
import { MainComponent } from '@modules/main/main.component';
import { LoginComponent } from '@modules/login/login.component';
import { HeaderComponent } from '@modules/main/header/header.component';
import { FooterComponent } from '@modules/main/footer/footer.component';
import { MenuSidebarComponent } from '@modules/main/menu-sidebar/menu-sidebar.component';
import { BlankComponent } from '@pages/blank/blank.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ProfileComponent } from '@pages/profile/profile.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RegisterComponent } from '@modules/register/register.component';
import { DashboardComponent } from '@pages/dashboard/dashboard.component';
import { ToastrModule } from 'ngx-toastr';
import { MessagesComponent } from '@modules/main/header/messages/messages.component';
import { NotificationsComponent } from '@modules/main/header/notifications/notifications.component';

import { CommonModule, DatePipe, registerLocaleData } from '@angular/common';
import localeEn from '@angular/common/locales/en';
import { UserComponent } from '@modules/main/header/user/user.component';
import { ForgotPasswordComponent } from '@modules/forgot-password/forgot-password.component';
import { RecoverPasswordComponent } from '@modules/recover-password/recover-password.component';
import { LanguageComponent } from '@modules/main/header/language/language.component';
import { MainMenuComponent } from './pages/main-menu/main-menu.component';
import { SubMenuComponent } from './pages/main-menu/sub-menu/sub-menu.component';
import { MenuItemComponent } from './components/menu-item/menu-item.component';
import { ControlSidebarComponent } from './modules/main/control-sidebar/control-sidebar.component';
import { StoreModule } from '@ngrx/store';
import { authReducer } from './store/auth/reducer';
import { uiReducer } from './store/ui/reducer';
import { ProfabricComponentsModule } from '@profabric/angular-components';
import { SidebarSearchComponent } from './components/sidebar-search/sidebar-search.component';
import { NgxGoogleAnalyticsModule } from 'ngx-google-analytics';
import { environment } from 'environments/environment';
import { ActivityTabComponent } from './pages/profile/activity-tab/activity-tab.component';
import { TimelineTabComponent } from './pages/profile/timeline-tab/timeline-tab.component';
import { SettingsTabComponent } from './pages/profile/settings-tab/settings-tab.component';
import { PostComponent } from './pages/profile/post/post.component';
import { InfoBoxComponent } from './components/info-box/info-box.component';
import { SmallBoxComponent } from './components/small-box/small-box.component';
import { ContentHeaderComponent } from './components/content-header/content-header.component';
import { LoadingComponent } from './components/loading/loading.component';
import { OverlayLoadingComponent } from './components/overlay-loading/overlay-loading.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { WebsiteComponent } from './pages/website/website.component';
import { WebNavbarComponent } from './pages/web-navbar/web-navbar.component';
import { WebFooterComponent } from './pages/web-footer/web-footer.component';
import { SwiperModule } from 'swiper/angular';
import { DetailViewComponent } from './pages/detail-view/detail-view.component';
import { InvoiceComponent } from './pages/invoice/invoice.component';
import { AddNewProductComponent } from './pages/admin/add-new-product/add-new-product.component';
import { QuillModule } from 'ngx-quill';
import { NgxSpinnerModule } from 'ngx-spinner';
import { ConfigLoader } from '@services/config.loader';
import { ConfigService } from '@services/config.service';
import { ProductViewComponent } from './pages/admin/product-view/product-view.component';
import { FilterPipe } from '@components/filter-pipe/filter.pipe';
import { EnquiryComponent } from './pages/enquiry/enquiry.component';
import { BillComponent } from './pages/bill/bill.component';
import { ShopBillListTableComponent } from './pages/admin/shop-bill-list-table/shop-bill-list-table.component';
import { BarcodePrintPageComponent } from './pages/barcode-print-page/barcode-print-page.component';
import { FreeStageEntryPageComponent } from './pages/admin/free-stage-entry-page/free-stage-entry-page.component';
import { AddShippingDetailsComponent } from './pages/add-shipping-details/add-shipping-details.component';
import { CustomerLoginPageComponent } from './pages/customer/customer-login-page/customer-login-page.component';
import { CartPageComponent } from './pages/customer/cart-page/cart-page.component';
import { AddCategoryComponent } from './pages/admin/add-category/add-category.component';
import { InfiniteScrollModule } from "ngx-infinite-scroll";
import { MyOrdersComponent } from './pages/customer/my-orders/my-orders.component';
import { OrderProcessingComponent } from './pages/admin/order-processing/order-processing.component';
import { DispatchManagementComponent } from './pages/admin/dispatch-management/dispatch-management.component';
import { TransactionDetailsComponent } from './pages/admin/transaction-details/transaction-details.component';
import { UserActivityLogComponent } from './pages/admin/user-activity-log/user-activity-log.component';
import { ReportDetailsComponent } from './pages/admin/report-details/report-details.component';
import { VariantViewComponent } from './pages/variant-view/variant-view.component';
import { LegalPolicyComponent } from './pages/admin/policy-details/legal-policy/legal-policy.component';
import { ExpenseMasterComponent } from './pages/admin/expense-module/expense-master/expense-master.component';
import { DailyExpenseEntryComponent } from './pages/admin/expense-module/daily-expense-entry/daily-expense-entry.component';
import { DailyExpenseViewComponent } from './pages/admin/expense-module/daily-expense-view/daily-expense-view.component';


registerLocaleData(localeEn, 'en-EN');

@NgModule({
  declarations: [
    AppComponent,
    MainComponent,
    LoginComponent,
    HeaderComponent,
    FooterComponent,
    MenuSidebarComponent,
    BlankComponent,
    ProfileComponent,
    RegisterComponent,
    DashboardComponent,
    MessagesComponent,
    NotificationsComponent,
    UserComponent,
    ForgotPasswordComponent,
    RecoverPasswordComponent,
    LanguageComponent,
    MainMenuComponent,
    SubMenuComponent,
    MenuItemComponent,
    ControlSidebarComponent,
    SidebarSearchComponent,
    ActivityTabComponent,
    TimelineTabComponent,
    SettingsTabComponent,
    PostComponent,
    InfoBoxComponent,
    SmallBoxComponent,
    ContentHeaderComponent,
    LoadingComponent,
    OverlayLoadingComponent,
    WebsiteComponent,
    WebNavbarComponent,
    WebFooterComponent,
    DetailViewComponent,
    InvoiceComponent,
    AddNewProductComponent,
    ProductViewComponent,
    FilterPipe,
    EnquiryComponent,
    BillComponent,
    ShopBillListTableComponent,
    BarcodePrintPageComponent,
    FreeStageEntryPageComponent,
    AddShippingDetailsComponent,
    CustomerLoginPageComponent,
    CartPageComponent,
    AddCategoryComponent,
    MyOrdersComponent,
    OrderProcessingComponent,
    DispatchManagementComponent,
    TransactionDetailsComponent,
    UserActivityLogComponent,
    ReportDetailsComponent,
    VariantViewComponent,
    LegalPolicyComponent,
    ExpenseMasterComponent,
    DailyExpenseEntryComponent,
    DailyExpenseViewComponent,
  ],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    AppRoutingModule,

    // State management
    StoreModule.forRoot({ auth: authReducer, ui: uiReducer }),

    // Third-party modules
    NgxSpinnerModule,
    ToastrModule.forRoot({
      timeOut: 3000,
      positionClass: 'toast-top-right',
      preventDuplicates: true,
    }),
    NgxGoogleAnalyticsModule.forRoot(environment.GA_ID),
    FontAwesomeModule,
    QuillModule.forRoot(),
    SwiperModule,
    InfiniteScrollModule,
    ProfabricComponentsModule,
    HttpClientModule, // for HttpClient compatibility
  ],
  providers: [provideHttpClient(withInterceptorsFromDi()),
  {
    provide: APP_INITIALIZER,
    useFactory: ConfigLoader,
    deps: [ConfigService],
    multi: true,
  },
    DatePipe]
})
export class AppModule { }
